(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bb-up-close"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('bb-up-close')) {
  customElements.define('bb-up-close', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      const data = this.querySelector('[data-up-data]');
      if (!data) return;
      this.ready = true;
      this.data = JSON.parse(data.textContent);
      this.form = this.querySelector('form');
      this.price = this.querySelector('[data-price]');
      this.initialPrice = this.price.textContent;
      this.selected = this.data.options.map((_,i) => {
        const values = [...new Set(this.data.variants.map(v=>v.options[i]))];
        return values.length === 1 ? values[0] : null;
      });
      this.querySelectorAll('[data-enhanced],[data-swap]').forEach(e=>e.hidden=false);
      this.querySelector('[data-swap]')?.addEventListener('click',()=>this.swap());
      if (!this.form) return;
      this.add = this.querySelector('[data-add]');
      this.querySelectorAll('[data-size]').forEach(button=>button.addEventListener('click',()=>{
        const index = Number(button.closest('[data-option-index]').dataset.optionIndex);
        this.selected[index] = button.dataset.size;
        this.update();
      }));
      this.querySelectorAll('select[data-option-index]').forEach(select=>select.addEventListener('change',()=>{
        this.selected[Number(select.dataset.optionIndex)] = select.value || null;
        const sizeIndex = this.data.options.findIndex(o=>o.toLowerCase()==='size');
        if(sizeIndex>=0 && !this.matches().some(v=>v.available)) this.selected[sizeIndex]=null;
        this.update();
      }));
      this.form.addEventListener('submit',event=>this.submit(event));
      this.update();
    }
    matches(ignore=-1,value=null) {
      return this.data.variants.filter(v=>this.selected.every((selection,i)=>i===ignore ? v.options[i]===value : !selection || v.options[i]===selection));
    }
    update() {
      this.querySelectorAll('[data-size]').forEach(button=>{
        const i=Number(button.closest('[data-option-index]').dataset.optionIndex);
        button.disabled=!this.matches(i,button.dataset.size).some(v=>v.available);
        button.setAttribute('aria-pressed',String(this.selected[i]===button.dataset.size));
      });
      this.variant=this.selected.every(Boolean) ? this.matches()[0] : null;
      this.price.textContent=this.variant ? this.variant.price : this.initialPrice;
      const compare=this.querySelector('[data-compare]');
      compare.textContent=this.variant?.compare||'';compare.hidden=!this.variant?.compare;
      this.form.elements.id.value=this.variant?.id||'';
      this.form.elements.id.disabled=!this.variant?.available;
      this.add.disabled=!this.variant?.available;
      this.add.textContent=this.variant ? (this.variant.available ? this.data.add : this.data.sold) : this.data.select;
      const choice=this.selected.filter(Boolean).filter(v=>!['Classic Polo','Premium Anti Wrinkle'].includes(v)).join(' · ');
      this.querySelector('[data-selection]').textContent=choice ? this.data.selected+' '+choice : this.data.select;
      this.querySelector('[data-details]').href=this.dataset.productUrl+(this.variant?'?variant='+this.variant.id:'');
      const sizeIndex=this.data.options.findIndex(o=>o.toLowerCase()==='size');
      const size=sizeIndex>=0 ? this.selected[sizeIndex] : null;
      const find=this.querySelector('[data-find-size]');
      if(!this.findBase){this.findBase=find.getAttribute('href');this.findLabel=find.textContent;}
      const url=new URL(this.findBase,location.origin);
      if(size){const normalized=size==='XXL'?'2XL,XXL':size==='3XL'?'3XL,XXXL':size;url.searchParams.set('filter.v.option.size',normalized);url.searchParams.set('filter.v.availability','1');}
      find.href=url.pathname+url.search;
      find.textContent=size?this.data.browse.replace('__size__',size):this.findLabel;
      this.querySelector('[data-message]').hidden=true;
      this.querySelector('[data-bag]').hidden=true;
    }
    swap() {
      const main=this.querySelector('.bb-close__photo');
      const inset=this.querySelector('[data-swap] img');
      for(const attribute of ['src','srcset','alt']){const current=main.getAttribute(attribute);main.setAttribute(attribute,inset.getAttribute(attribute)||'');inset.setAttribute(attribute,current||'');}
      const button=this.querySelector('[data-swap]');
      const swapped=button.getAttribute('aria-pressed')!=='true';
      button.setAttribute('aria-pressed',String(swapped));
      this.querySelector('[data-swap-label]').firstChild.textContent=(swapped?this.data.full:this.data.detail)+' ';
    }
    async submit(event) {
      event.preventDefault();
      if(this.busy||!this.variant?.available)return;
      this.busy=true;this.add.disabled=true;this.add.textContent=this.data.adding;
      const variant=this.variant;
      const controls=[...this.querySelectorAll('[data-size],select[data-option-index]')];
      controls.forEach(e=>e.disabled=true);
      const message=this.querySelector('[data-message]');message.hidden=true;
      const cart=document.querySelector('cart-notification')||document.querySelector('cart-drawer');
      const payload={id:variant.id,quantity:1};
      if(cart?.getSectionsToRender){payload.sections=cart.getSectionsToRender().map(s=>s.id);payload.sections_url=location.pathname;cart.setActiveElement?.(this.add);}
      let deferred;
      const eventType=window.StandardEvents?.CartLinesUpdateEvent;
      if(eventType){deferred=eventType.createPromise();deferred.promise.catch(()=>{});this.dispatchEvent(new eventType({action:'add',context:'product',lines:[{merchandiseId:variant.id,quantity:1}],promise:deferred.promise}));}
      try {
        const response=await fetch(this.data.cartAdd,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(payload)});
        const result=await response.json();
        if(!response.ok||result.status){throw new Error(typeof result.description==='string'?result.description:this.data.error);}
        if(deferred){fetch(this.data.cart+'.js').then(r=>r.json()).then(c=>deferred.resolve({cart:eventType.createCartFromAjaxResponse(c)})).catch(e=>deferred.reject(e));}
        try {if(typeof publish==='function'&&typeof PUB_SUB_EVENTS!=='undefined')publish(PUB_SUB_EVENTS.cartUpdate,{source:'bb-up-close',productVariantId:variant.id,cartData:result});}catch(e){}
        try {if(result.sections&&cart?.renderContents)cart.renderContents(result);}catch(e){}
        this.update();
        message.textContent=this.data.added;message.hidden=false;
        this.querySelector('[data-bag]').hidden=false;
      } catch(error) {
        this.dispatchEvent(new CustomEvent('bb:feature-result', {bubbles:true,detail:{feature:'up_close',result:'error'}}));
        deferred?.reject(error);
        this.update();message.textContent=error.message||this.data.error;message.hidden=false;
      } finally {
        this.busy=false;this.querySelectorAll('select[data-option-index]').forEach(e=>e.disabled=false);
        this.add.disabled=!this.variant?.available;this.add.textContent=this.variant?.available?this.data.add:this.data.select;
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
